// extracted by mini-css-extract-plugin
export default {"section":"EffortTypesSection_section__0VJwH","effortGrid":"EffortTypesSection_effortGrid__MC4iq"};